import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Collapse from 'react-bootstrap/Collapse';
import Form from 'react-bootstrap/Form';
/*
// Lähettää komennen backendille
const sendCommand = (mac, command, value) => {
    if (!socket) return;
  
    let commandToSend = `${mac.toString()} ${command} ${value}`;
    console.log('sendCommand', mac, command, value)
    socket.emit('command', commandToSend);  
  }
  
  // Lähettää backendille muutetun configin. Backend tallentaa sen serverille.
  const sendConfigUpdate = (newconfig) => {
    if (!socket) return;
  
    console.log('sendConfigUpdate', newconfig);
    socket.emit('configupdate', newconfig);
  }
*/  


const CommandInterface = ({mac, type, measurements, main_callback, show}) => {
    const [ output, setOutput ] = useState(0.0);
    const [ uunit, setUunit ] = useState(0);
    const [ iunit, setIunit ] = useState(0);
    //const [ depolStatusOn, setDepolStatusOn ] = useState(false); // TODO poista. tämä siirretty sitelle
    const [ interrupt, setInterrupt ] = useState(0); // TODO: interrupt 500 (ms) ja ohjaus takaisin interrupt 0
    const [ lastCommand, setlastCommand ] = useState('');
    const [ initialized, setInitialized ] = useState(false);
    const [ ref1Selected, setRef1Selected ]  = useState(false);
    const [ ref2Selected, setRef2Selected ]  = useState(false);
  
  
  
    if (type == 'm2ex')
    {
      return <div></div>;
    }
  
    // initialize
    if (!initialized && measurements != undefined) {
      console.log('initialize', measurements)
  
      // Output
      setOutput(Number(measurements['setpoint']).toFixed(1));
      // Depol - Jos mittauksessa tullut mtype=dep tai mtype=end(depoltestin viimeinen virraton potentiaalimittaus)
      //setDepolStatusOn( (measurements['mtype'] == 'dep' || measurements['mtype'] == 'end') ); //TODO: pois täältä
      // Interrupt - Jos mittauksessa output=remoff
      setInterrupt( (measurements['output'] == 'remoff') ? 0 : 1 );
  
      // Cycling - mittauksessa output=cycling
      //setCycle( (measurements['output'] == 'cycling') ? 1 : 0 );
  
      // Refs in use
      setRef1Selected( (measurements['ref1abs'] === 'na') ? false: true );
      setRef2Selected( (measurements['ref2abs'] === 'na') ? false: true );
  
      setInitialized(true);
    }


    const sendCommand = (mac, command, value) => {
        main_callback("sendcommand", "commandinterface", {mac,command,value});
    }
    
  
    const changeOutput = (event) => {
      console.log('changeoutput', event.target.value)
      var newValue = event.target.value;
      if (event.target.value < 0)
        newValue = 0;
  
      if (event.target.value > 100)
      newValue = 100;
  
  
      setOutput(newValue);
    }
  
    const blurOutput = () => {
      // Skaalaus 0-100% = 0-255
      //let scaledOutput = Math.round(output * 2.55);
      //console.log('blur',scaledOutput, output)
      sendCommand(mac, 'output', output);
    }
  
  
    const changeActiveRefs = (ref1, ref2) => {
      console.log('refs', ref1, ref2)
  
      let refsinuse = 'none';
  
      if (ref1 && ref2)
        refsinuse = 'both';
      else if (ref1)
        refsinuse = 'r1';
      else if (ref2)
        refsinuse = 'r2';
  
      sendCommand(mac, 'refsinuse', refsinuse);
  
    }
  
    const commandToSend = () => {
      sendCommand(mac, lastCommand);
    }
  
  
   
    return (
      <Collapse in={show}>
      <tr className="commandinterface">
        <td colSpan="15"> 
            <Table striped hover info="true">
              <thead>
                <tr>
                  <th>Output-%</th>
                  <th>Identify</th>
  
                  <th>Interrupt</th>
                  <th>Mode</th>
                  <th>Set U gain</th>
                  <th>Set I gain</th>
                  <th>I Unit</th>
                  <th>U Unit</th>
                  <th>Refs in use</th>
                  <th>Command</th>
                </tr>
  
              </thead>
  
              <tbody>
  
              
              <td>
                {/* Pattern ei toimi */}
                <input value={output} type="number" decimal onChange={changeOutput} onBlur={blurOutput} min='0' max='100' pattern="^\d*(\.\d{0,2})?$" />             
              </td>
              <td>
                <button 
                  type="button"
                  className="btn btn-primary"
                  onClick={() => sendCommand(mac, 'identify')}>Send
                </button>
              </td>
              <td>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setInterrupt((interrupt === 0) ? 1 : 0);
                  sendCommand(mac, 'interrupt', interrupt);
                }}>{(interrupt !== 0) ? 'Start' : 'Stop'}</button>
              </td>
              <td>auto</td>
              <td>
                
              </td>
              <td>
                
              </td>
              <td>
                <button 
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                  setIunit((iunit === 0) ? 1 : 0);
                  sendCommand(mac, 'setiunit', iunit);
                }}>I unit</button>
              </td>
              <td>
                <button 
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                  setUunit((uunit === 0) ? 1 : 0);
                  sendCommand(mac, 'setuunit', uunit);
                }}>U unit</button>
              </td>
              <td>
                <div>
                  <Form>
                    <Form.Check // prettier-ignore
                      type="switch"
                      id="custom-switch"
                      label="Ref 1"
                      checked={ref1Selected}
                      onChange={(event) => { setRef1Selected(!ref1Selected); console.log('ref1', event.target.checked); changeActiveRefs(event.target.checked, ref2Selected);  } }
                    />
                    <Form.Check // prettier-ignore
                      type="switch"
                      label="Ref 2"
                      id="disabled-custom-switch"
                      checked={ref2Selected}
                      onChange={(event) => { setRef2Selected(!ref2Selected); console.log('ref2',  event.target.checked); changeActiveRefs(ref1Selected, event.target.checked); } }
                    />
                  </Form>
                </div>
              </td>
              <td>
                <input value={lastCommand} onChange={(event) => { setlastCommand(event.target.value); }} onBlur={commandToSend} />             
              </td>  
              </tbody>          
            </Table>
        </td> 
        </tr>
  
        </Collapse>
    )
  }
  
  export default CommandInterface
  //export {sendCommand}
  //export {sendConfigUpdate}